import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { hasLogin } from "../services/LoginService";
import { form } from "../services/HttpService";

Vue.use(Vuex);
 
export default new Vuex.Store({
  state: {
    routeNavTitle: "",
    beforeNavTitle: "",
    isMyPage: false,
    hasChange: false,
    checkId: "817485bf52754d8880cb97789f88141d",
    isCheckUs: false,
    userData: undefined,
    checkSideMenu: "edit",
  },
  getters: {},
  mutations: {
    openVuex(state, word) {
      state.routeNavTitle = word;
      if (word !== "联系我们") {
        state.beforeNavTitle = word;
      }
    },
    checkId(state, word) {
      state.checkId = word;
    },
    checkSideMenu(state, word) {
      state.checkSideMenu = word;
    },
    setUserData(state, userData) {
      state.userData = userData;
    },
  },
  actions: {
    openVuex({ commit }, word) {
      commit("openVuex", word);
    },
    checkId({ commit }, word) {
      commit("checkId", word);
    },
    checkSideMenu({ commit }, word) {
      commit("checkSideMenu", word);
    },
    async hasLogin({ commit, dispatch }) {
      try {
        let result = await hasLogin();
        let data = result.data;
        if (data.code === 200) {
          commit("setUserData", data.data);
          localStorage.setItem("userId", data.data.userId);
          localStorage.setItem("userData", JSON.stringify(data.data));
          localStorage.setItem("nickName", data.data.userName);
          localStorage.setItem(
            "profilePictureUrl",
            data.data.profilePictureUrl
          );
          localStorage.setItem("roleIds", data.data.roleIds);
          return true;
        } else {
          dispatch("clearAuthAndRedirect");
          return false;
        }
      } catch (error) {
        dispatch("clearAuthAndRedirect");
        return false;
      }
    },
    clearAuthAndRedirect({ dispatch }) {
      dispatch("openVuex", "");
      dispatch("checkId", "817485bf52754d8880cb97789f88141d");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("nickName");
      localStorage.removeItem("profilePictureUrl");
      localStorage.removeItem("roleIds");
      localStorage.removeItem("userData");
      form('/sso/login', { callback: window.location.href });
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});
